import gql from "graphql-tag";

export default gql`query Vats {
    vats {
        id
        vrn,
        action,
        payload,
        response,
        status,
        userid,
        timestamp,
        user {
            id
            name
        }
    } 
  }`